import { render, staticRenderFns } from "./polymers-video.vue?vue&type=template&id=bad95c30&scoped=true"
import script from "./polymers-video.vue?vue&type=script&lang=js"
export * from "./polymers-video.vue?vue&type=script&lang=js"
import style0 from "./polymers-video.vue?vue&type=style&index=0&id=bad95c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad95c30",
  null
  
)

export default component.exports